import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const BulkUsers = async (data) => {
  try {
    return await postData(`/ai-trade/bulk-users`, data);
  } catch (error) {
    console.error(error);
  }
};
